import React, { useState, useEffect } from "react";
import ReactDOM from "react-dom";
import { Button, message, Modal, Input } from "antd";
import { lib } from "react-single-app";
import Header from "../components/header";
import "antd/dist/antd.css";
import "./index.less";
const { TextArea } = Input;

function Index() {
    let [systemList, setSystemList] = useState([]);
    let [visible, setVisible] = useState(false);
    let [data, setData] = useState(null);
    let [applyReason, setApplyReason] = useState("");

    function fetchSystemList() {
        lib.request({
            url: "/ucenter-account/current/systemList",
            success: res => setSystemList(res),
        });
    }

    function submitHandle() {
        if (!applyReason) {
            message.warning("请输入申请理由");
            return;
        }
        lib.request({
            url: "/ucenter-account/user/customer/applyOpenSystem",
            data: { ...data, applyReason },
            success: res => {
                message.success("申请开通中");
                fetchSystemList();
                setVisible(false);
            },
        });
    }

    useEffect(() => {
        fetchSystemList();
    }, []);

    return (
        <div className="index-contain">
            <Header />
            <div className="index-content">
                <div className="welcome">
                    <span className="hello">您好！</span>
                    <span>请选择系统</span>
                </div>
                {systemList.map((item, index) => {
                    return (
                        <div key={index} className="system_item">
                            <div className="item_title">
                                <b>{item.systemName}</b>
                            </div>
                            <div className="remark">{item.remark}</div>
                            {item.status === 1 && (
                                <a className="button" href={item.url}>
                                    进入系统
                                </a>
                            )}
                            {item.status === 0 && (
                                <a
                                    className="button"
                                    onClick={() => {
                                        setVisible(true);
                                        setData({ systemCode: item.systemCode });
                                    }}>
                                    申请开通
                                </a>
                            )}
                            {item.status === 2 && <a className="not-btn">待审核</a>}
                        </div>
                    );
                })}
            </div>
            <Modal
                title="申请开通系统"
                visible={visible}
                onCancel={() => {
                    setVisible(false);
                }}
                okText="确认"
                cancelText="取消"
                onOk={() => submitHandle()}>
                <TextArea
                    rows={4}
                    value={applyReason}
                    onChange={e => setApplyReason(e.currentTarget.value)}
                />
            </Modal>
        </div>
    );
}

export default Index;
